module.exports = __webpack_public_path__ + "img/Frame 427319319.c609bbfd.png";